<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Submission Table Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Samples" active>
        <h3>Samples</h3>
        <sample-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :show_columns="sample_columns"
          show_add_btn
        />
      </b-tab>
      <b-tab title="Test Packages">
        <h3>Test Packages</h3>
        <test-package-server-table
          :analytes="analyte_collection"
          :sample_types="sample_type_collection"
          :show_columns="[
            'name',
            'sample_type.name',
            'test_package_group.name',
            'description',
            'cost',
            'cost_add_on'
          ]"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SampleServerTable from "@/components/lab/sample/SampleServerTable";
import TestPackageServerTable from "@/components/lab/testpackage/TestPackageServerTable";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "SubmissionDetailCardstack",
  components: {
    SampleServerTable,
    TestPackageServerTable
  },
  data() {
    return {
      loading: true,
      analyte_collection: null,
      sample_type_collection: null,
      sample_columns: [
        "pid",
        "receiving_id",
        "submission.pid",
        "identifier",
        "number",
        "created_at",
        "received",
        "prepped",
        "scheduled",
        "actions"
      ]
    };
  },
  methods: {
    async init() {
      const payload = {
        sort: [
          {
            logic: "sortAddAsc",
            field: "name"
          }
        ],
        limit: "all",
        message: this.$bvToast
      };

      this.analyte_collection = await getCollection({
        ...payload,
        collection_type: "analyte"
      });
      this.sample_type_collection = await getCollection({
        ...payload,
        collection_type: "sample_type"
      });

      this.loading = false;
    }
  },
  created() {
    this.loading = true;

    this.init();
  }
};
</script>
